export const getApiUrl = (suffix: string): string => {
  return `${process.env.NEXT_PUBLIC_BALLZ_API_URL}${
    suffix.startsWith('/') ? suffix : `/${suffix}`
  }`;
};
